<div class="mass-upload-grid-submission-log">
  @if (errorMessage) {
    <div class="error-message">
      <p>{{ errorMessage }}</p>
    </div>
  }

  <div class="ag-grid-container">
    @if (caseId) {
      <ag-grid-angular
        #agGrid
        [rowData]="singleCaseRowData"
        [columnDefs]="columnDefs"
        (gridReady)="onGridReady($event)"
      ></ag-grid-angular>
    }
    @else {
      <ag-grid-angular
        #agGrid
        [columnDefs]="columnDefs"
        [gridOptions]="gridOptions"
        [pagination]="true"
        [paginationPageSize]="paginationPageSize"
        [cacheBlockSize]="cacheBlockSize"
        [rowModelType]="'infinite'"
        (gridReady)="onGridReady($event)"
      ></ag-grid-angular>
    }

    @if (isLoading) {
      <div class="loading-mask">
        <mat-spinner diameter="100"></mat-spinner>
      </div>
    }
  </div>
</div>
